import { NavLink } from 'react-router-dom';
import BrandMark from './BrandMark';
import { APP_NAME, GODOT_ANDROID_APK_URL, GODOT_APP_URL } from '../appInfo';

export default function Nav() {
  return (
    <nav className="nav">
      <span className="nav-brand">
        <BrandMark size={24} />
        <span>{APP_NAME}</span>
      </span>
      <NavLink to="/dashboard">ダッシュボード</NavLink>
      <NavLink to="/duels">デュエル</NavLink>
      <NavLink to="/decks">デッキ</NavLink>
      <NavLink to="/lottery">抽選</NavLink>
      <NavLink to="/cards">カード</NavLink>
      <NavLink to="/exports">かき出し</NavLink>
      <NavLink to="/shoot">撮影</NavLink>
      {/* Godot のブラウザ版（同じ出どころの /godot/。別のページなので SPA の遷移ではなく普通のリンク。ログインは localStorage から引き継がれる） */}
      <a href={GODOT_APP_URL} target="_blank" rel="noreferrer" data-testid="nav-godot">Godot 版</a>
      {/* Godot の Android 版の APK（いつも最新。端末のブラウザで押すと落ちてくる。「提供元不明のアプリ」を許して入れる） */}
      <a href={GODOT_ANDROID_APK_URL} download data-testid="nav-godot-android" title="Android の端末で落として入れる（提供元不明のアプリを許可）">Android 版</a>
    </nav>
  );
}
